// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__hb0vi","title":"AfterFrontImage_title__znt54"};